import keyIcon from '../../assets/images/forgotPasswordFormKey.png'
import keyIcon2x from '../../assets/images/forgotPasswordFormKey@2x.png'

export interface KeyIconProps {
  size?: number
  className?: string
}

/**
 * Key Icon Component
 *
 * Displays the password reset key icon from Figma design.
 * Automatically uses @2x version for high-DPI displays.
 *
 * @example
 * <KeyIcon size={100} />
 *
 * @example
 * <KeyIcon size={64} className="my-custom-class" />
 */
export function KeyIcon({ size = 100, className = '' }: KeyIconProps) {
  return (
    <img
      src={keyIcon}
      srcSet={`${keyIcon} 1x, ${keyIcon2x} 2x`}
      alt="Key"
      width={size}
      height={size}
      className={className}
    />
  )
}
